module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"settingsIcons":{"changePassword":"Passwort neu vergeben","changeEmail":"E-Mail-Adresse ändern","serviceCode":"Freischaltcode eingeben","serviceCodeRequest":"Freischaltcode anfordern"}}}')
  delete Component.options._Ctor
}
